import { MaterialAndQualityDto } from './material-and-quality-dto';
export class CreatePoDto {
    customerModal : string;
    customerLocationIdsModel: string;
    customerPOType: string;
    poNumberModel: string;
    distributorModel: string;
    materialNQualityArray : MaterialAndQualityDto[];
    noOfPO : number;
    cutomerName: string;
    constructor(
        customerModal : string,
        customerLocationIdsModel: string,
        customerPOType: string,
        poNumberModel: string,
        distributorModel: string,
        materialNQualityArray : MaterialAndQualityDto[],
        noOfPO : number,
        cutomerName: string,
        
    ){
        this.customerModal=customerModal ;
        this.customerLocationIdsModel=customerLocationIdsModel;
        this.customerPOType=customerPOType;
        this.poNumberModel=poNumberModel;
        this.distributorModel=distributorModel;
        this.materialNQualityArray=materialNQualityArray ;
        this.noOfPO=noOfPO ;  
        this.cutomerName=cutomerName;
    }
}
